import { CHAPTERS } from "../../data/content";
import { FadeUp, MaskLineInView } from "./Reveal";

export const OurStory = () => {
  const c = CHAPTERS[0];
  return (
    <section
      id="story"
      data-testid="story-section"
      className="bg-[#fbf8f0] py-12 lg:py-16"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {/* Sticky sidebar */}
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-28">
              <FadeUp>
                <span className="font-body text-[#c56928] text-[13px] tracking-[0.3em] uppercase">
                  {c.kicker}
                </span>
              </FadeUp>
              <h2 className="font-display text-[#07412b] text-[52px] sm:text-7xl lg:text-[110px] mt-2 leading-tight">
                <MaskLineInView>{c.label}</MaskLineInView>
              </h2>
              <div className="gold-rule w-32 mt-4 hidden lg:block" />
            </div>
          </div>

          {/* Content */}
          <div className="lg:col-span-8 lg:pt-4">
            <div className="space-y-5 max-w-2xl">
              {c.paragraphs.map((p, i) => (
                <FadeUp key={i} delay={i * 0.05}>
                  <p
                    className={`font-body font-light leading-relaxed text-[#07412b] ${
                      i === 0
                        ? "text-xl sm:text-2xl leading-relaxed first-letter:font-display first-letter:text-6xl first-letter:float-left first-letter:mr-3 first-letter:leading-[0.8] first-letter:text-[#c56928] first-letter:font-semibold"
                        : "text-base sm:text-lg text-[#07412b]/80"
                    }`}
                  >
                    {p}
                  </p>
                </FadeUp>
              ))}
              <FadeUp delay={0.1}>
                <p className="font-script text-[#ddb128] text-5xl sm:text-6xl pt-4">
                  — for you, me &amp; us.
                </p>
              </FadeUp>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
